import Vue from 'vue';
export function setValue(name,value) {
  Vue.prototype[name] = value;
}


// WEBPACK FOOTER //
// ./src/api/setValue.js